import {BottomSheet} from 'react-spring-bottom-sheet';
import type {
  IDeliveryOrder,
  IStore,
} from '../../../../../../../services/hookService/getOrderDetails/types';
import React from 'react';
import cn from 'classnames';
import CustomRadio from '../../../../../../../components/mazraeKit/customRadio';
import dummyIcon from '../../../../../../../assets/image/inputGroups/machinery.svg';

export type AdvertisementType = {
  id: number;
  guid: string;
  quantity: number;
  title_snapshot: string;
  price_snapshot: number;
  discount_price: number;
  advertisement: string;
  store_order: number;
  image?: string;
  link?: string;
  sub_brand_image?: string;
  parentOrderGuid: string;
  parentCreatedAt: string;
  storeOrderGuid: string;
  supplyDate: string;
  approvedAt: string;
  supplierProvideAt: string;
  storeOrderStep: any;
  store_detail: IStore | undefined;
  delivery: IDeliveryOrder | null;
};

interface ISelectAdsBottomSheetProp {
  advertisementList: AdvertisementType[];
  setSelectedAdvertisement: React.Dispatch<React.SetStateAction<string>>;
  selectedAdvertisement: string;
  isOpen: boolean;
  setScannerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export function SelectAdsBottomSheet({
  advertisementList,
  setSelectedAdvertisement,
  selectedAdvertisement,
  isOpen,
  setScannerOpen,
  setIsOpen,
}: ISelectAdsBottomSheetProp) {
  const onSelectAdvertisementHandler = (id: string) => {
    setSelectedAdvertisement(id);
    setScannerOpen(true);
    setIsOpen(false);
  };
  const filterNoLinkAdv = advertisementList.filter(adv => !adv?.link);
  const isAnyAdHasLink = advertisementList.some(item => item?.link);
  const isAllAdvHasLink = isAnyAdHasLink && filterNoLinkAdv.length === 0;
  return (
    <BottomSheet open={isOpen}>
      <div className="flex relative flex-col gap-4 p-6 w-full">
        <i
          className="absolute top-6 left-6 text-2xl text-gray-500 icon-nameClose-remove"
          onClick={() => setIsOpen(false)}
        />
        <p className="flex justify-center mt-2 w-full text-sm text-gray-950 font-Regular">
          انتخاب محصول
        </p>
        <span
          className={cn(
            'w-full text-sm text-right text-gray-600',
            isAllAdvHasLink && 'text-center',
          )}
        >
          {isAllAdvHasLink
            ? 'همه آگهی ها دارای لینک هستند'
            : 'کیو آر کد مربوط به کدام محصول است؟'}
        </span>

        {filterNoLinkAdv.length > 0 && (
          <div className="flex flex-col items-start">
            {filterNoLinkAdv.map((item: AdvertisementType, index: number) => (
              <div
                key={`${item.guid}-in-bs`}
                onClick={() => onSelectAdvertisementHandler(item.advertisement)}
                className={cn(
                  'flex items-center w-full gap-3 content-center ',
                  !(filterNoLinkAdv.length - 1 === index) &&
                    'border-b-[1px] border-gray-50 pb-3',
                )}
              >
                <CustomRadio
                  readOnly
                  title=""
                  value={item.guid}
                  checked={item.guid === selectedAdvertisement}
                />
                <img
                  className="w-14 h-14"
                  src={item?.image ?? dummyIcon}
                  alt="product"
                />
                <h6 className="text-sm">{item.title_snapshot}</h6>
              </div>
            ))}
          </div>
        )}
      </div>
    </BottomSheet>
  );
}
